var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockMilestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1C7.91531 1 5.8125 3.0187 5.8125 5.5V7.3H4.875C3.84094 7.3 3 8.1073 3 9.1V17.2C3 18.1927 3.84094 19 4.875 19H16.125C17.1591 19 18 18.1927 18 17.2V9.1C18 8.1073 17.1591 7.3 16.125 7.3H15.1875V5.5C15.1875 3.0187 13.0847 1 10.5 1ZM7.6875 5.5C7.6875 4.0114 8.94938 2.8 10.5 2.8C12.0506 2.8 13.3125 4.0114 13.3125 5.5V7.3H7.6875V5.5ZM16.1269 17.2H11.4375V15.1498C11.9953 14.8375 12.375 14.2633 12.375 13.6C12.375 12.6073 11.5341 11.8 10.5 11.8C9.46594 11.8 8.625 12.6073 8.625 13.6C8.625 14.2624 9.00469 14.8375 9.5625 15.1498V17.2H4.875V9.1H16.125L16.1269 17.2Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockMilestone);
export default __webpack_public_path__ + "static/media/lock-milestone.ce99f5587ab68d02745374f6983a2222.svg";
export { ForwardRef as ReactComponent };